import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles/Global.css'; // ✅ Main Design System & Global Styles


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// Service Worker is intentionally disabled.
// This ensures every new deploy is immediately visible to all users
// without requiring cache clears or hard refreshes.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
